<div class="flex flex-col">

  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <span *ngIf="!addingAddress" class="font-semibold">Addresses</span>
      <span *ngIf="addingAddress && address.id === 0" class="font-semibold">Add an Address</span>
      <div *ngIf="addingAddress && address.id > 0" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Update</span>
        <span class="font-semibold">Address</span>
      </div>
    </div>

    <div class="gap-1 flex justify-self-end items-center" *ngIf="!addingAddress">
      <span *ngIf="addresses.length > 0 && canEdit && entityType != sharedService.hospitalLicense">Click to Edit</span>

      <button type="button" *ngIf="canEdit && (!limitEntries || addresses.length < limitTo)" mat-button color="primary" (click)="toggleAddressForm(true)">Add Address</button>

      <button type="button" *ngIf="canEdit" mat-button color="primary" (click)="getAddresses(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
    </div>

  </div>

  <div *ngIf="!addingAddress" class="md:mt-2">
    <div *ngIf="canEdit">
      <mat-table [dataSource]="addressSource" matSort #addressSort="matSort" aria-label="addresses" class="portal-table">
        <ng-container matColumnDef="street">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Street</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">Street</span>
            {{ address.street }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="city">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">City</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">City</span>
            {{ address.city }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="state">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">State</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">State</span>
            {{ address.state }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="zip">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">Zip</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">Zip</span>
            {{ address.zip }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="county">
          <mat-header-cell *matHeaderCellDef mat-sort-header="">County</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">County</span>
            {{ address.county }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="types">
          <mat-header-cell *matHeaderCellDef>Types</mat-header-cell>
          <mat-cell *matCellDef="let address">
            <span class="mobile-label">Type</span>
            <div class="flex flex-col">
              <span *ngIf="address.archived">Archived</span>
              <div *ngFor="let type of address.addressTypes">
                <span>{{type.type}}</span>
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="addressColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: addressColumns" class="portal-interactive-row" [ngClass]="row.archived? 'portal-archived' : ''"
          (click)="canEdit && !(isRenewal && entityType == sharedService.hospitalLicense && hasPhysicalType(row))? editAddress(row) : ''" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (canEdit && !(isRenewal && entityType == sharedService.hospitalLicense && hasPhysicalType(row))? editAddress(row) : '')" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (canEdit && !(isRenewal && entityType == sharedService.hospitalLicense && hasPhysicalType(row))? editAddress(row) : '')"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" #addressPaginator="matPaginator">
      </mat-paginator>
    </div>

    <div class="flex flex-col" *ngIf="!canEdit">
      <div class="flex flex-col md:flex-row md:gap-4" *ngFor="let address of addresses">
        <span>{{ address.street }}</span>
        <span>{{address.city}}, {{address.state}} {{address.zip}}</span>
        <span>{{ address.county }}</span>
        <div class="flex flex-col">
          <span *ngIf="address.archived">Archived</span>
          <div *ngFor="let type of address.addressTypes">
            <span>{{type.type}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="addingAddress" class="md:mt-2">
    <div class="gap-1 flex justify-self-end items-center">
      <button type="button" *ngIf="address.id > 0 && canEdit" mat-button color="warn" (click)="deleteAddress(address)">Delete Address</button>

      <button type="button" *ngIf="address.id > 0" mat-button color="warn" (click)="archiveAddress(address, !address.archived)">{{ address.archived? 'Un-Archive' : 'Archive' }}</button>

      <button type="button" *ngIf="addresses.length > 0" mat-button color="warn" (click)="toggleAddressForm(false)">Close</button>
    </div>

    <form [formGroup]="addressForm">
      <div class="flex flex-col gap-2">
        <div class="flex flex-col md:flex-row gap-2">
          <mat-form-field class="md:w-1/3">
            <mat-label>Street</mat-label>
            <input matInput formControlName="street" (blur)="autoSave()">
            <mat-error *ngIf="addressForm.get('street')?.invalid">
              Street is required
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/3">
            <mat-label>City</mat-label>
            <input matInput formControlName="city" (blur)="autoSave()">
            <mat-error *ngIf="addressForm.get('city')?.invalid">
              City is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <mat-form-field class="md:w-1/3">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" (selectionChange)="autoSave()">
              <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
            </mat-select>
            <mat-error *ngIf="addressForm.get('state')?.invalid">
              Please select a state
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/3">
            <mat-label>Zip</mat-label>
            <input matInput formControlName="zip" (blur)="autoSave()">
            <mat-error *ngIf="addressForm.get('zip')?.hasError('required')">
              Zip is required
            </mat-error>
            <mat-error *ngIf="addressForm.get('zip')?.hasError('pattern')">
              Zip should match this format: 99999 or 99999-1234
            </mat-error>
          </mat-form-field>

          <mat-form-field class="md:w-1/3">
            <mat-label>County</mat-label>
            <mat-select formControlName="county" (selectionChange)="autoSave()">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let county of sharedService.getCountiesForState(this.addressForm.get('state')?.value ?? '')" value={{county}}>{{county}}</mat-option>

            </mat-select>
            <!--  <mat-error *ngIf="addressForm.get('county').invalid">
              County is required
            </mat-error> -->
          </mat-form-field>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <mat-form-field class="md:w-1/3">
            <mat-label>Types</mat-label>
            <mat-select formControlName="types" multiple [compareWith]="compareFn" (blur)="autoSave()">
              <mat-option *ngFor="let type of addressTypes" [value]="type">{{type.type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="gap-1 flex justify-self-end items-center">
      <button type="button" *ngIf="addressForm.valid && address.id === 0" mat-button color="primary" (click)="createAddress()">Save Address</button>

      <button type="button" *ngIf="addressForm.valid && address.id > 0 && canEdit" mat-button color="primary" (click)="saveAddress()">Save Address</button>

      <button type="button" *ngIf="addresses.length > 0" mat-button color="warn" (click)="toggleAddressForm(false)">Close</button>
    </div>

  </div>
</div>
